export default function (nga, admin) {
  var subscriptionHistorySuspended = admin.getEntity("SubscriptionsHistorySuspended");
    
  function fetchProductNames() {
    return fetch('/api/public/getAllPackages?apikey=abec967abb9d7e0a97618c58fcb9fce8')
      .then(response => response.json())
      .then(data => {
        return data.map(item => ({ value: item.combo_id, label: item.name }));
      })
      .catch(error => {
        console.error('Error fetching product names:', error);
        return [];
      });
  }

  subscriptionHistorySuspended
    .listView()
    .title(
      '<h4>Suspended Subscriptions History <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .perPage(50)
    .batchActions([])
    .fields([
      nga
        .field("smartcard_no")
        .label("Smartcard No."),
      nga
        .field("stb_no")
        .label("STB No."),
      nga
        .field("product_type")
        .label("Product Type"),
      nga
        .field("product_name")
        .label("Product Name"),
      nga
        .field("service_type")
        .label("Service Type"),
      // nga
      //   .field("activation_date", "date")
      //   .label("Activation Date"),
      // nga
      //   .field("deactivation_date", "date")
      //   .label("Deactivation Date"),
    ])
    .exportFields([subscriptionHistorySuspended.listView().fields()]);

  fetchProductNames().then(choices => {
    subscriptionHistorySuspended
      .listView()
      .filters([
        nga.field('product', 'choice')
          .attributes({ placeholder: 'Select Package' })
          .label('Product')
          .choices(choices),
        nga.field('report_date', 'date')
          .transform(function (value) {
            if(value != undefined){
              return value.toString();
            }
          })
          .attributes({ placeholder: 'Report Date' })
          .label('')
          .pinned(true),
      ]);
    return subscriptionHistorySuspended;
  });
}


// WEBPACK FOOTER //
// ./js/subscriptionHistorySuspended/config.js